import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { UserRound } from "lucide-react";
import { ESPACE_CLIENT_URL } from "@/data/site";
import ChatWidget from "./ChatWidget";
import { MobileCallBar } from "./MobileCallBar";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen bg-white pb-14 md:pb-0">
      <SiteHeader />
      <main><Outlet /></main>
      <SiteFooter />
      <a href={ESPACE_CLIENT_URL} aria-label="Espace client" data-testid="floating-espace-client-btn"
        className="fixed bottom-20 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-[#D82C2C] px-5 py-3 text-sm font-bold text-white shadow-xl ring-2 ring-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#b82323] md:bottom-5">
        <UserRound className="h-4 w-4" /><span className="hidden min-[370px]:inline">Espace client</span>
      </a>
      <ChatWidget />
      <MobileCallBar />
    </div>
  );
}
